import React from 'react';

const ChartMode = ({ singleChartMode, onChangeChartMode }) => (
  <div>
    <a
      href="#"
      onClick={(e) => {
        e.preventDefault();
        onChangeChartMode(!singleChartMode);
      }}
    >
      {singleChartMode ? 'Multiple' : 'Single'}
    </a>
  </div>
);

export default ChartMode;
